var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrandsDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 38,
    viewBox: "0 0 117 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4 29.8C16.1438 29.8 20.8 25.1438 20.8 19.4C20.8 13.6562 16.1438 9 10.4 9C4.65624 9 0 13.6562 0 19.4C0 25.1438 4.65624 29.8 10.4 29.8Z",
    fill: "#00bfa6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58 38C68.4934 38 77 29.4934 77 19C77 8.50659 68.4934 0 58 0C47.5066 0 39 8.50659 39 19C39 29.4934 47.5066 38 58 38Z",
    fill: "#00bfa6",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M106.5 29.8C112.244 29.8 116.9 25.1438 116.9 19.4C116.9 13.6562 112.244 9 106.5 9C100.756 9 96.1 13.6562 96.1 19.4C96.1 25.1438 100.756 29.8 106.5 29.8Z",
    fill: "#00bfa6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4 29.8C64.1438 29.8 68.8 25.1438 68.8 19.4C68.8 13.6562 64.1438 9 58.4 9C52.6562 9 48 13.6562 48 19.4C48 25.1438 52.6562 29.8 58.4 29.8Z",
    fill: "#00bfa6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandsDot);
export default __webpack_public_path__ + "static/media/brands-dot.446a15332dea131cbcae2ab49b1d1ea5.svg";
export { ForwardRef as ReactComponent };